import ConsultancyComponent from 'components/marketingSite/consultancy/ConsultancyComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type ConsultancyPageProps = WithBaseUrl;

const parseJSON = (resp: any): any => (resp.json ? resp.json() : resp);

const checkStatus = (resp: any): any => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp: any) => {
    throw resp;
  });
};

const headers = { 'Content-Type': 'application/json' };

const ConsultancyPage: React.FC<ConsultancyPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('consultancy');

  usePageTrack('Landing - Page Loaded');

  const { locale } = useRouter();

  const [succesCases, setSuccessCases] = useState([]);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/consultancy-success-cases?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => {
        const sorted = data.sort((a: any, b: any) => {
          return a.attributes.order < b.attributes.order ? -1 : 1;
        });

        setSuccessCases(sorted);
      });
  }, [locale]);

  return (
    <>
      <HeadMetadata
        title={t('consultancy.page_title')}
        url={APP_URLS.consultancy}
        desc={t('consultancy.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_consultancy.png'
        )}`}
      />
      <ConsultancyComponent cases={succesCases} />
    </>
  );
};

export default ConsultancyPage;

export const getStaticProps: GetStaticProps<ConsultancyPageProps> = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'consultancy'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
